import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { ServicesPage } from "./pages/ServicesPage";
import { ServiceDetailPage } from "./pages/ServiceDetailPage";
import { IndustriesPage } from "./pages/IndustriesPage";
import { AboutPage } from "./pages/AboutPage";
import { GovernmentPage } from "./pages/GovernmentPage";
import { GalleryPage } from "./pages/GalleryPage";
import { ContactPage } from "./pages/ContactPage";
import { QRLandingPage } from "./pages/QRLandingPage";
import { AdminPage } from "./pages/AdminPage";
import { FlyerPage } from "./pages/FlyerPage";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          {/* QR Code Landing Page - No header/footer for clean mobile experience */}
          <Route path="/estimate" element={<QRLandingPage />} />
          <Route path="/quote" element={<QRLandingPage />} />
          <Route path="/qr" element={<QRLandingPage />} />
          
          {/* Admin Dashboard - Password protected */}
          <Route path="/admin" element={<AdminPage />} />
          
          {/* Printable Flyer */}
          <Route path="/flyer" element={<FlyerPage />} />
          
          {/* Main Website with Header/Footer */}
          <Route path="/*" element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:slug" element={<ServiceDetailPage />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/government" element={<GovernmentPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
